import React from "react";
import { notification } from "antd";
import "./NotificationComponent.css";
export const NotificationComponent = (props) => {
  notification[props.type]({
    message: props.message,
    icon: props.icon,
    placement: props.placement,
    duration: props.duration,
    top: props.top,
    className: props.className,
  });
};
